import React, { useState } from "react";
import {
  delete_icon,
  view_icon,
  search_icon,
  edit_icon,
  user,
} from "../../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../components/Table/Table";

const SiteProfile = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [loader, setLoader] = useState(false);
  const [popup, setPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [owners, setOwners] = useState([
    {
      id: 1,
      name: "Robert",
      emailid: "robert@example.com",
      number: "9876543210",
      companyname: "ABC Constructions",
      companycode: "ABC123",
      sitename: "Green Villa",
      sitelocation: "Chennai",
      role: "Super Admin",
      status: "on",
    },
    {
      id: 2,
      name: "Thor",
      emailid: "thor@example.com",
      number: "9876501234",
      companyname: "XYZ Builders",
      companycode: "XYZ567",
      sitename: "Blue Heights",
      sitelocation: "Bangalore",
      role: "Admin",
      status: "off",
    },
    {
      id: 3,
      name: "Tony Stark",
      emailid: "tony@starkindustries.com",
      number: "9999988888",
      companyname: "Stark Industries",
      companycode: "STK001",
      sitename: "Iron Tower",
      sitelocation: "New York",
      role: "Admin",
      status: "on",
    },
    {
      id: 4,
      name: "Steve Rogers",
      emailid: "steve@avengers.com",
      number: "8888877777",
      companyname: "Shield Pvt Ltd",
      companycode: "SHD777",
      sitename: "Brooklyn Heights",
      sitelocation: "USA",
      role: "Admin",
      status: "off",
    },
    {
      id: 5,
      name: "Bruce Banner",
      emailid: "bruce@hulk.com",
      number: "7777766666",
      companyname: "Gamma Labs",
      companycode: "GAM888",
      sitename: "Hulk Tower",
      sitelocation: "Delhi",
      role: "Admin",
      status: "on",
    },
    {
      id: 6,
      name: "Natasha Romanoff",
      emailid: "natasha@shield.com",
      number: "6666655555",
      companyname: "Red Room Pvt Ltd",
      companycode: "RR009",
      sitename: "Black Widow Base",
      sitelocation: "Russia",
      role: "Admin",
      status: "off",
    },
    {
      id: 7,
      name: "Clint Barton",
      emailid: "clint@hawk.com",
      number: "5555544444",
      companyname: "Hawk Constructions",
      companycode: "HK777",
      sitename: "Hawk Nest",
      sitelocation: "London",
      role: "Admin",
      status: "on",
    },
    {
      id: 8,
      name: "Peter Parker",
      emailid: "peter@spiderman.com",
      number: "4444433333",
      companyname: "Daily Bugle Ltd",
      companycode: "DB123",
      sitename: "Queens Tower",
      sitelocation: "New York",
      role: "Admin",
      status: "on",
    },
    {
      id: 9,
      name: "Wanda Maximoff",
      emailid: "wanda@scarlet.com",
      number: "3333322222",
      companyname: "Vision Corp",
      companycode: "VSN456",
      sitename: "Westview",
      sitelocation: "Sokovia",
      role: "Admin",
      status: "off",
    },
    {
      id: 10,
      name: "Vision",
      emailid: "vision@mindstone.com",
      number: "2222211111",
      companyname: "Mindstone Pvt Ltd",
      companycode: "MS001",
      sitename: "Mind Tower",
      sitelocation: "Los Angeles",
      role: "Admin",
      status: "on",
    },
  ]);

  const handleStatus = ({ id }) => {
    const updatedData = [...owners]; // Create a copy of the data
    const currentStatus = updatedData[id].status || "on"; // Default to "on" if undefined

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
    // let value = data.filter((ele, i) => i == id ? ele.status == "off" ? "on" : "off")
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: " Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Email ID",
        accessor: "emailid",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Mobile Number",
        accessor: "number",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Profile Image",
        accessor: "profileimage",
        Cell: ({ value, row }) => {
          return <img src={user} alt="image" className="list-img" />;
        },
      },
      {
        Header: "Company Name",
        accessor: "companyname",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Company Code",
        accessor: "companycode",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Site Name",
        accessor: "sitename",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Site Location",
        accessor: "sitelocation",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  // if (givenpermissions?.includes("CAN-Status-ADMINS")) {
                  handleStatus(row);
                  // handleStatus(row.original.id);
                  // }
                }}
                className={`${
                  value == "off" ? "deactive-btn" : "active-btn"
                } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
              >
                {value == "off" ? "De-active" : " Active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                <button
                  onClick={() => {
                    navigate("/site-view-profile", { state: { type: "view" } });
                  }}
                  className="cust-btn "
                >
                  <img src={view_icon} alt="" className=" edit-btn " />
                </button>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:2
        </h2>
        <div className="d-flex gap-3">
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={search_icon} className="search" />
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
    </div>
  );
};

export default SiteProfile;
